import { render, staticRenderFns } from "./add-service.vue?vue&type=template&id=598b9c64&scoped=true&"
import script from "./add-service.vue?vue&type=script&lang=js&"
export * from "./add-service.vue?vue&type=script&lang=js&"
import style0 from "./add-service.vue?vue&type=style&index=0&id=598b9c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598b9c64",
  null
  
)

export default component.exports